var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 24,
    rx: 2,
    fill: "#3957A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 -4H1V28H33V-4Z",
    fill: "#3957A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1351 15.6656H13.0391L14.3493 8.1347H16.4454L15.1351 15.6656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2762 8.1347L9.278 13.3145L9.04126 12.199V12.1993L8.33653 8.81278C8.33653 8.81278 8.251 8.1347 7.34203 8.1347H4.03797L4 8.26238C4 8.26238 5.01024 8.45854 6.19221 9.12286L8.01289 15.6656H10.1972L13.5328 8.1347H11.2762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4585 13.0019L26.5594 10.183L27.1796 13.0019H25.4585ZM27.7649 15.6656H29.6893L28.0113 8.1347H26.3264C25.5478 8.1347 25.3582 8.69566 25.3582 8.69566L22.2324 15.6656H24.4174L24.8536 14.5472H27.519L27.7649 15.6656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3958 9.9456L22.6944 8.32832C22.6944 8.32832 21.7718 8 20.8098 8C19.7694 8 17.2991 8.42528 17.2991 10.4931C17.2991 12.439 20.1991 12.463 20.1991 13.4845C20.1991 14.5062 17.5977 14.3238 16.7397 13.6794L16.4277 15.3696C16.4277 15.3696 17.3637 15.7955 18.7937 15.7955C20.2244 15.7955 22.3824 15.1024 22.3824 13.2173C22.3824 11.2592 19.4574 11.0765 19.4574 10.2253C19.4574 9.37376 21.4991 9.4832 22.3958 9.9456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04126 12.1993L8.33653 8.81278C8.33653 8.81278 8.251 8.1347 7.34203 8.1347H4.03797L4 8.26238C4 8.26238 5.58771 8.5699 7.11042 9.72286C8.56642 10.8256 9.04126 12.1993 9.04126 12.1993Z",
    fill: "#F9A533"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.6ca98df3204285ff435c34618373e9c0.svg";
export { ForwardRef as ReactComponent };